@use "../../styles/breakpoint.module.scss" as *;

.root {
    visibility: inherit;
}

.carousel {
    --slides-visible: var(--slides-visible-cms, 3);
    --gutters: calc(var(--slides-visible) - 1);
    --gutter-width: var(--grid-gap);
    --gutter-space: calc(var(--gutter-width) * var(--gutters));
    --width: calc((100% - var(--gutter-space)) / var(--slides-visible));

    @media ($below-mobile) {
        --slides-visible: 1;
    }

    > * {
        display: grid;
        grid-auto-flow: column;
        grid-auto-columns: var(--width);
        gap: var(--gutter-width);
    }
}

.card {
    padding: var(--spacer-24);
    border-radius: var(--border-radius-md);
    height: 100%;
}

.figure {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: space-between;
    height: 100%;
    margin: 0;
}

.avatar {
    width: auto;
    height: var(--spacer-80);
    margin-bottom: var(--spacer-24);
    object-fit: contain;
}

.quote {
    margin: 0;
    font: var(--font-q-20);

    &::before {
        content: "“";
    }

    &::after {
        content: "”";
    }
}

.citation {
    margin-top: var(--spacer-16);
    font: var(--font-s-14);

    &::before {
        content: "— ";
    }
}

.controls {
    inset-inline: calc(40px - var(--container-margin));

    button {
        box-shadow: var(--box-shadow-3);
    }
}
